import { type FC } from 'react'
import styles from './deleteConfirmation.module.scss'
import { Button } from 'common/components/Button/Button'
import { BUTTON_MODIFIER } from 'common/constants/buttonConstants'
import { Checkbox, Modal } from 'antd'
import { useToggle } from 'react-use'

type DeleteConfirmationDialogProps = {
  isOpen: boolean
  onConfirm: (sendSms: boolean) => Promise<void>
  onCancel: () => void
  isLoading?: boolean
}

export const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const [sendSms, setSendSms] = useToggle(true)

  const handleConfirm = async () => {
    await onConfirm(sendSms)
    setSendSms(true)
  }

  const handleCancel = () => {
    onCancel()
    setSendSms(true)
  }

  return (
    <Modal
      classNames={{ content: styles.modalContainer }}
      title='Confirm appointment delete?'
      open={isOpen}
      onCancel={handleCancel}
      keyboard
      footer={null}
      destroyOnHidden>
      <div className={styles.content}>
        <div className={styles.checkboxContainer}>
          <Checkbox
            checked={sendSms}
            onClick={setSendSms}
            className={styles.checkbox}
            disabled={isLoading}>
            Send cancelation text message
          </Checkbox>
        </div>

        <div className={styles.actions}>
          <Button
            className={styles.button}
            modifier={BUTTON_MODIFIER.PRIMARY}
            onClick={handleConfirm}
            loading={isLoading}
            disabled={isLoading}>
            Yes
          </Button>
          <Button
            className={styles.button}
            modifier={BUTTON_MODIFIER.SECONDARY}
            onClick={handleCancel}
            disabled={isLoading}>
            No
          </Button>
        </div>
      </div>
    </Modal>
  )
}
